import {
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Typography
} from "@mui/material";
import {Link} from "react-router-dom";


export function ShelterItem(props) {
    return(
        <Card>
            <CardActionArea LinkComponent={Link} to={`/shelter/${props.id}`}>
                <CardMedia
                    component="img"
                    height="140"
                    image={props.image}
                    alt="obrazcok"
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {props.name}
                    </Typography>
                    <p className={"shelter-address"}>
                        {props.address}
                    </p>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button LinkComponent={Link} to={`/shelter/${props.id}`} size="medium" color="primary">
                    Úprava
                </Button>
            </CardActions>
        </Card>
    );
}

